// src/components/ModalFooter.js
import React from "react";
import { Box, Button } from "@mui/material";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";

export default function ModalFooter({
  showDelete = false,
  deleteLabel = "Delete",
  onDelete,

  onCancel = () => {},
  cancelLabel = "Cancel",

  onSave,
  saveLabel = "Save",
  saveColor = "primary",

  sx = {},
}) {
  return (
    <Box sx={{ width: "100%", px: 2, pb: 2, ...sx }}>
      {/* DESKTOP (md+) */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          width: "100%",
          mt: 1,
        }}
      >
        {/* DELETE */}
        {showDelete ? (
          <Button
            variant="contained"
            color="error"
            sx={{ flex: 1 }}
            onClick={onDelete}
            startIcon={<DeleteForeverRoundedIcon fontSize="small" />}
          >
            {deleteLabel}
          </Button>
        ) : (
          <Box sx={{ flex: 1 }} />
        )}

        {/* CANCEL */}
        <Button
          variant="outlined"
          color="inherit"
          sx={{ flex: 1 }}
          onClick={onCancel}
          startIcon={<CloseRoundedIcon fontSize="small" />}
        >
          {cancelLabel}
        </Button>

        {/* SAVE */}
        <Button
          variant="contained"
          color={saveColor}
          sx={{ flex: 1 }}
          onClick={onSave}
          startIcon={<DoneRoundedIcon fontSize="small" />}
        >
          {saveLabel}
        </Button>
      </Box>

      {/* MOBILE (xs) */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          gap: 1.5,
          width: "100%",
          alignItems: "stretch",
          mt: 2,
        }}
      >
        <Button
          variant="contained"
          color={saveColor}
          sx={{ width: "100%" }}
          onClick={onSave}
          startIcon={<DoneRoundedIcon fontSize="small" />}
        >
          {saveLabel}
        </Button>

        <Button
          variant="outlined"
          color="inherit"
          sx={{ width: "100%" }}
          onClick={onCancel}
          startIcon={<CloseRoundedIcon fontSize="small" />}
        >
          {cancelLabel}
        </Button>

        {showDelete && (
          <Button
            variant="contained"
            color="error"
            sx={{ width: "100%" }}
            onClick={onDelete}
            startIcon={<DeleteForeverRoundedIcon fontSize="small" />}
          >
            {deleteLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
}
